import { TooltipLayer } from 'www/modules/tooltip/tooltip-layer'
import { IconLink } from 'www/svg-icons/lib/icon-link';
import ShareFacebookSVG from 'www/svg-icons/share-facebook';
import ShareLinkedInSVG from 'www/svg-icons/share-linkedin';
import ShareTwitterSVG from 'www/svg-icons/share-twitter';
import ShareEmailSVG from 'www/svg-icons/share-email';
import { debounceTime } from 'rxjs/operators';
import { ShareWidgetApi } from 'www/apis/share-widget-api';
export class PromosShareLayer extends TooltipLayer{
    constructor(api) {
        super(api);
        this._shareApi = null;
        this._isHoverActive = true;
    }
    init(){
        super.init();
        this.el.classList.add('medscape-share-layer');
        this.el.appendChild(this.iconsListEl);

    }
    get shareApi(){
        if(this._shareApi==null){
            this._shareApi = new ShareWidgetApi();
        }
        return this._shareApi;
    }
    get iconsListEl(){
        if(this._iconsListEl==null){
            let iconsListEl = document.createElement('ul');
            iconsListEl.appendChild(this.facebookEl)
            iconsListEl.appendChild(this.twitterEl);
            iconsListEl.appendChild(this.linkedinEl);
            iconsListEl.appendChild(this.emailEl);
            this._iconsListEl = iconsListEl;
        }
        return this._iconsListEl;
    }

    get facebookEl(){
        if(this._facebookItemEl==null){
            let el = document.createElement('li');
            let iconLink = new IconLink(ShareFacebookSVG.useSprite);
            el.appendChild(iconLink.el);
            iconLink.el.classList.add('facebook-icon');
            iconLink.onClick.subscribe(e=>{
                this.shareApi.shareFacebook();
            })
            el.appendChild(iconLink.el);
            this._facebookItemEl = el;
        }
        return this._facebookItemEl;
    }


    get twitterEl(){
        if(this._twitterItemEl==null){
            let el = document.createElement('li');
            let iconLink = new IconLink(ShareTwitterSVG.useSprite);
            el.appendChild(iconLink.el);
            iconLink.el.classList.add('twitter-icon');
            iconLink.onClick.subscribe(e=>{
                this.shareApi.shareTwitter();
            })
            el.appendChild(iconLink.el);
            this._twitterItemEl = el;

        }
        return this._twitterItemEl;
    }

    get linkedinEl(){
        if(this._linkedInItemEl==null){
            let el = document.createElement('li');
            let iconLink = new IconLink(ShareLinkedInSVG.useSprite);
            el.appendChild(iconLink.el);
            iconLink.el.classList.add('linkedin-icon');
            iconLink.onClick.subscribe(e=>{
                this.shareApi.shareLinkedin();
            })
            el.appendChild(iconLink.el);
            this._linkedInItemEl = el;

        }
        return this._linkedInItemEl;
    }
    get emailEl(){
        if(this._emailItemEl==null){
            let el = document.createElement('li');
            let iconLink = new IconLink(ShareEmailSVG.useSprite);
            el.appendChild(iconLink.el);
            iconLink.el.classList.add('email-icon');
            iconLink.onClick.subscribe(e=>{
                this.shareApi.shareEmail();
            })
            this._emailItemEl = el;

        }
        return this._emailItemEl;
    }

}
